import React from "react";
import PropTypes from "prop-types";
import { ModalRegisterProvider } from "../ModalRegister/index.js";
import { ModalPortalProvider } from "../ModalPortal/index.js";

/**
 * This component creates a separation at the application root between the modal elements and other
 * elements on the page.
 *
 * This is helpful for accessibility reasons because it allows us to easily hide the other elements
 * from screen readers when modals are open. Additionally, this helps avoid styling discrepencies
 * created by inherited properties when rendering a modal.
 *
 * If you use `Layout` from [@xo-union/tk-component-layout](/packages/@xo-union/tk-component-layout)
 * you do not need to use this component.
 */
const LayoutRoot = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ModalPortalProvider, null, portalRef => /*#__PURE__*/React.createElement(ModalRegisterProvider, null, anyModalIsOpen => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": anyModalIsOpen ? 'true' : undefined
  }, children), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": anyModalIsOpen ? undefined : 'true',
    ref: portalRef
  }))));
};
process.env.NODE_ENV !== "production" ? LayoutRoot.propTypes = {
  children: PropTypes.node
} : void 0;
export default LayoutRoot;